<div>
  <h3>
    {{
      'pages.cybersocxdr.dashboard.fieldTitles.securitynavigatormanager'
        | translate
    }}
  </h3>
  <div
    class="d-flex flex-row flex-wrap justify-content-around"
    style="width: 100%"
  >
    <div *ngFor="let navigatorData of graphData; index as i">
      <app-securitynavigator
        [data]="navigatorData"
        [title]="data[i].name"
        [subtitle]="dataPercent[i].toString() + '%'"
      ></app-securitynavigator>
    </div>
  </div>
</div>
